import React from 'react';
import { connect } from 'react-redux'
import { withTranslation } from "react-i18next";

import * as types from 'reducer/actionTypes';
import { isEmpty } from 'script/common';

class AdapterUpdate extends React.Component {
	onSubmitUpdate = (e) => {
		e.preventDefault();
		var value={
			adapter: document.getElementById('adapter_update_name').value,
			className: document.getElementById('adapter_update_className').value,
			description: document.getElementById('adapter_update_description').value,
			files: document.getElementById('adapter_update_file').files
		}

		if(!this.errorCheck(value)){
			this.props.fetchAdapterUpdateRequest(value, e)
		}
	}

	errorCheck = (value) => {
		var errorLabel={}
		
		if(isEmpty(value.adapter)){
			errorLabel={
				...errorLabel,
				name:"aa.button.err.required"
			}
		}
		if(isEmpty(value.className)){
			errorLabel={
				...errorLabel,
				className:"aa.button.err.required"
			}
		}
		if(isEmpty(value.description)){
			errorLabel={
				...errorLabel,
				description:"aa.button.err.required"
			}
		}
		if(isEmpty(value.files)){
			errorLabel={
				...errorLabel,
				adapterFile:"aa.button.err.required"
			}
		}
		
		this.props.setErrorLabel(errorLabel)

		if(Object.keys(errorLabel).length > 0){
			return true
		}else{
			return false
		}
	}

	onClickCancel = (e) => {
		this.props.setAdapterUpdateModal()
	}

	onChangeUpdateFileInput = (e) => {
		var fileName = e.target.value.split('\\');
		document.getElementById('label_update_file').innerText = fileName[fileName.length-1]
	}

	render(){
		const {t} = this.props;

		return (
			<div className="modal_overlay" style={{display: this.props.adapterUpdate.modalVisible ? 'block' : 'none'}}>
				<div className="modal_dialog" style={{display: this.props.adapterUpdate.modalVisible ? 'block' : 'none'}}>
					<form className="form" onSubmit={this.onSubmitUpdate} encType="multipart/form-data">
						<div className="dialog">
							<div className="dialog_tl">{t('au.text.label.title')}</div>
							<div className="dialog_content">
								<div className="section">
									<div className="item_label">{t('aa.text.label.adapter.name')}</div>
									<input type="text" className="item_input" id="adapter_update_name" value={this.props.adapterUpdate.data.adapter || ''} readOnly disabled/>
									<div className="error" style={{display:'block'}}>{t(this.props.adapterUpdate.errorLabel.adapter)}</div>
									
									<div className="item_label">{t('aa.text.label.adapter.class')}</div>
									<input type="text" className="item_input" id="adapter_update_className" defaultValue={this.props.adapterUpdate.data.className || ''}/>
									<div className="error" style={{display:'block'}}>{t(this.props.adapterUpdate.errorLabel.className)}</div>
									
									<div className="item_label">{t('aa.text.lable.adapter.description')}</div>
									<input type="text" className="item_input" id="adapter_update_description" defaultValue={this.props.adapterUpdate.data.description || ''}/>
									<div className="error" style={{display:'block'}}>{t(this.props.adapterUpdate.errorLabel.description)}</div>
									
									<div className="item_label">{t('aa.text.lable.adapter.file')}</div>
									<label htmlFor="adapter_update_file">
										<div className="file_input" id="label_update_file">{t('aa.text.lable.adapter.upload.file')}</div>
										<input type="file" id="adapter_update_file" onChange={this.onChangeUpdateFileInput} style={{display:"none"}}/>
									</label>
									<div className="error" style={{display:'block'}}>{t(this.props.adapterUpdate.errorLabel.adapterFile)}</div>
									<div className="btn_wrap">
										<button className="btn_text_b btn_text_w" type="reset" onClick={this.onClickCancel}>{t('aa.button.label.cancel')}</button>
										<button className="btn_text_b">{t('aa.button.label.register')}</button>
									</div>
								</div>
							</div>
						</div>
					</form>
				</div>
			</div>
	)}
}

// state를 해당 컴포넌트의 props로 연결
const mapStateToProps = (reducers) => {
	return{
		adapterUpdate: reducers.adapter.adapterUpdate,
	}
}

// 컴포넌트의 함수형 poprs를 실행했을때, 지정한 action을 dispatch 하도록 설정
const mapDispatchToProps = (dispatch) => {
	return{
		setErrorLabel: (value) => {dispatch({type: types.SET_ADAPTER_UPDATE_ERRORLABEL,errorLabel:value})},
		setAdapterUpdateModal: () => {dispatch({type: types.SET_ADAPTER_UPDATE_MODAL, data:{}})},
		fetchAdapterUpdateRequest: (value, e) => {dispatch({type: types.FETCH_SET_ADAPTER_UPDATE_REQUEST, value:value, target:e.target})},
	}
}

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(AdapterUpdate))